export const UI_LANGUAGES = ["en", "zh-CN"] as const;
export type UiLanguage = (typeof UI_LANGUAGES)[number];

export const UI_THEMES = ["system", "light", "dark"] as const;
export type UiTheme = (typeof UI_THEMES)[number];

export const DEFAULT_UI_LANGUAGE: UiLanguage = "en";
export const DEFAULT_UI_THEME: UiTheme = "light";

export function isValidUiLanguage(value: unknown): value is UiLanguage {
  return (
    typeof value === "string" && UI_LANGUAGES.includes(value as UiLanguage)
  );
}

export function isValidUiTheme(value: unknown): value is UiTheme {
  return typeof value === "string" && UI_THEMES.includes(value as UiTheme);
}
